var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "result" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("Password changed successfully")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action" }, [
        _c("div", { staticClass: "toLogin" }, [
          _c("h3", [
            _vm._v("Will return to the login page in "),
            _c("span", [_vm._v(_vm._s(_vm.time))]),
            _vm._v("seconds.")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icons" }, [
      _c("i", { staticClass: "el-icon-success" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a918faa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a918faa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forget/Step4.vue
// module id = 2KUC
// module chunks = 2